import Modeler from 'bpmn-js/lib/Modeler';
import inherits from 'inherits';
import CustomModule from './custom-js';

// Function to explort Custom modeler
export default function CustomModeler(options) {
  Modeler.call(this, options);
}
// Call inherits to sync CustomModeler with modeler
inherits(CustomModeler, Modeler);
// Set Prototype modules of CustomModeler
CustomModeler.prototype._modules = [].concat(
  CustomModeler.prototype._modules,
  [
    CustomModule
  ]
);
